import { render } from "./BurnOqcScreen.vue?vue&type=template&id=94639108&scoped=true"
import script from "./BurnOqcScreen.vue?vue&type=script&lang=js"
export * from "./BurnOqcScreen.vue?vue&type=script&lang=js"

import "./BurnOqcScreen.vue?vue&type=style&index=0&id=94639108&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94639108"]])

export default __exports__